const initialState = {};

// -------------------------------------------------------
// -------------------------------------------------------
const reducer = (state = initialState, action) => {
  // -------------------------------------------------------
  switch (action.type) {
   
    case "SET_INVOICE_DATA":
      return { ...state, invoice: action.invoice };

    default:
      return state;
  }
};

export default reducer;
